// Logo del header. Linkable al sitio web FD por defecto; cuando la
// sesión viene de una webview de app nativa, NO es link (`linkableLogo`
// = false en el legacy) para evitar abrir el sitio web fuera de la app.

import { getFdPublicConfig } from "../window";
import { VALID_NATIVE_APP_VALUES } from "../nativeApp";

export interface LogoProps {
  nativeApp: string | null;
}

export function Logo({ nativeApp }: LogoProps) {
  const linkable =
    !nativeApp ||
    !(VALID_NATIVE_APP_VALUES as readonly string[]).includes(nativeApp);

  const inner = <div className="logo" />;

  return (
    <div id="kc-logo">
      {linkable ? <a href={getFdPublicConfig().BASE_URL}>{inner}</a> : inner}
    </div>
  );
}
